export default __webpack_public_path__ + "static/media/cochera.05febcda.svg";